import React from 'react';
import PageTemplate from '../../components/template/PageTemplate/PageTemplate';
import { COUPON_PAGE_NAME } from '../../constants/service/app/couponConstants';
import { CouponCopyWrap } from '../../views/coupon-v2/save/CouponSaveWrap';

const CouponCopy = () => {
  return (
    <PageTemplate pageName={COUPON_PAGE_NAME.COUPON_COPY}>
      <CouponCopyWrap />
    </PageTemplate>
  );
};

export default CouponCopy;
